import React from 'react';

import Checkbox from '@mui/material/Checkbox';
import FormControl, { FormControlProps } from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { SelectProps } from '@mui/material/Select/Select';
import { Typography } from '@mui/material';

export interface MultiSelectOption {
  value: string | number;
  label: string;
}

interface Props {
  options: MultiSelectOption[];
  selectedOptions: (string | number)[];
  onChange: (selectedIds: MultiSelectOption['value'][]) => void;
  variant: SelectProps['variant'];
  label: string;
  formControlProps?: FormControlProps;
  fullWidth: boolean;
}

export const MultipleSelectCheckmarks: React.FC<Props> = ({
  options,
  selectedOptions,
  onChange,
  variant,
  label,
  fullWidth,
  formControlProps
}) => {
  const handleChange = (
    event: SelectChangeEvent<MultiSelectOption['value'][]>
  ) => {
    const {
      target: { value: values }
    } = event;
    onChange(
      // On autofill, we get a stringified value.
      typeof values === 'string' ? values.split(', ') : values
    );
  };

  return (
    <>
      <FormControl
        sx={{ width: fullWidth ? '100%' : 400 }}
        {...formControlProps}
      >
        <InputLabel
          sx={[
            { overflow: 'unset', lineHeight: '8px' },
            {
              '&.Mui-focused': {
                top: '5px'
              }
            }
          ]}
          id="multiple-select-checkmarks-label"
        >
          {label}
        </InputLabel>
        <Select
          variant={variant}
          labelId="multiple-select-checkmarks-label"
          label={label}
          id="multiple-select-checkmarks"
          multiple
          value={selectedOptions}
          onChange={handleChange}
          size="small"
          renderValue={(values) =>
            values
              .map(
                (value) =>
                  options.find((option) => option.value === value)?.label
              )
              .join(', ')
          }
        >
          {options.map(({ value, label }) => (
            <MenuItem key={label + value} value={value}>
              <Checkbox checked={selectedOptions.includes(value)} />
              <ListItemText primary={label} />
            </MenuItem>
          ))}
        </Select>
        <Typography sx={{ paddingLeft: 2 }} variant="caption" color="error">
          {formControlProps?.error ?? ''}
        </Typography>
      </FormControl>
    </>
  );
};
